import { useState } from 'react'

export enum NpvrSearchFormFields {
asset = "asset",
programId = "programId",
program = "program",
episode = "episode",
status = "status",
channel = "channel",
channelNumber = "channelNumber",
startTime = "startTime",
actualStartTime = "actualStartTime",
endTime = "endTime",
actualEndTime = "actualEndTime",
source = "source",
lastEvent = "lastEvent",
}

function getInitialStringSearchFormMapValues(){
  const stringSearchFormMap = new Map<NpvrSearchFormFields, string>()
  stringSearchFormMap.set(NpvrSearchFormFields.asset,"")
  stringSearchFormMap.set(NpvrSearchFormFields.programId,"")
  stringSearchFormMap.set(NpvrSearchFormFields.program,"")
  stringSearchFormMap.set(NpvrSearchFormFields.episode,"")
  stringSearchFormMap.set(NpvrSearchFormFields.status,"")
  stringSearchFormMap.set(NpvrSearchFormFields.channel,"")
  stringSearchFormMap.set(NpvrSearchFormFields.channelNumber,"")
  stringSearchFormMap.set(NpvrSearchFormFields.source,"")

  return stringSearchFormMap
}

function getInitialDateSearchFormMapValues(){
  const dateSearchFormMap = new Map<NpvrSearchFormFields, {start: string, end: string}>()
  const initialDateValues = { start: '', end: '' }
  dateSearchFormMap.set(NpvrSearchFormFields.startTime,initialDateValues)
  dateSearchFormMap.set(NpvrSearchFormFields.actualStartTime,initialDateValues)
  dateSearchFormMap.set(NpvrSearchFormFields.endTime,initialDateValues)
  dateSearchFormMap.set(NpvrSearchFormFields.actualEndTime,initialDateValues)
  dateSearchFormMap.set(NpvrSearchFormFields.lastEvent,initialDateValues)

  return dateSearchFormMap
}

export default function useSearchForm() {
  const [stringSearchForm, setStringSearchForm] = useState(getInitialStringSearchFormMapValues())
  const [dateSearchForm, setDateSearchForm] = useState(getInitialDateSearchFormMapValues())

  const resetState = () => {
    setStringSearchForm(getInitialStringSearchFormMapValues())
    setDateSearchForm(getInitialDateSearchFormMapValues())
  }

  return {
    stringSearchForm,
    setStringSearchForm,
    dateSearchForm,
    setDateSearchForm,
    resetState
  }
}
